<!-- Headline -->
@switch (this.hierarchyPath().length) {
  @case (1) {
    <h2 class="font-medium text-lg mt-8 text-wrap">{{ sectionTitle() }}</h2>
  }
  @case (2) {
    <h3 class="font-medium text-lg mt-4 text-wrap">{{ sectionTitle() }}</h3>
  }
  @case (3) {
    <h4 class="font-medium text-wrap">{{ sectionTitle() }}</h4>
  }
}

<!-- Content -->
@for (contentItem of section().content; track contentItem) {
  @switch (contentItem.type) {
    @case (ContentType.TEXT) {
      <app-text [text]="contentItem.body" />
    }

    @case (ContentType.ADDRESS) {
      <app-address [address]="contentItem" />
    }

    @case (ContentType.LIST) {
      <app-list
        [isEnumerated]="false"
        [items]="contentItem.content"
      />
    }

    @case (ContentType.LIST_ENUM) {
      <app-list
        [isEnumerated]="true"
        [items]="contentItem.content"
      />
    }
  }
}

<!-- Subsections -->
@if (section().subsections !== null) {
  @for (item of section().subsections; track item; let idx = $index) {
    <app-section
      [section]="item"
      [hierarchyPath]="getHierarchyPathChild(idx)"
    />
  }
}
